var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCouponSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "local_offer",
    clipPath: "url(#clip0_1447_5753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.841 9.64984L10.341 2.14984C10.041 1.84984 9.62435 1.6665 9.16602 1.6665H3.33268C2.41602 1.6665 1.66602 2.4165 1.66602 3.33317V9.1665C1.66602 9.62484 1.84935 10.0415 2.15768 10.3498L9.65768 17.8498C9.95768 18.1498 10.3743 18.3332 10.8327 18.3332C11.291 18.3332 11.7077 18.1498 12.0077 17.8415L17.841 12.0082C18.1493 11.7082 18.3327 11.2915 18.3327 10.8332C18.3327 10.3748 18.141 9.94984 17.841 9.64984ZM4.58268 5.83317C3.89102 5.83317 3.33268 5.27484 3.33268 4.58317C3.33268 3.8915 3.89102 3.33317 4.58268 3.33317C5.27435 3.33317 5.83268 3.8915 5.83268 4.58317C5.83268 5.27484 5.27435 5.83317 4.58268 5.83317Z",
    fill: "#667085"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1447_5753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponSvg);
export default __webpack_public_path__ + "static/media/CouponSvg.1beb4761d5ffa3e63bb9428b278b28cf.svg";
export { ForwardRef as ReactComponent };